export const AppConstants = {
	TIME_NEED_TO_RELOAD: 180000, // ~ 5 minutes,
	TRY_CONNECTE_ATTEMP: 500000
};
